import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  Hamburger, Pizza, ShoppingCartSimple, Pill, BeerBottle,
  BowlFood, Cake, Scissors, Stethoscope, DotsThreeOutline, PaintBrush, ArrowUpRight,
} from "@phosphor-icons/react";
import { fadeUp, stagger, viewport } from "../../lib/motion";

const delivery = [
  { name: "Lanches", icon: Hamburger, color: "text-maraca-amber", bg: "hover:bg-maraca-amber/10" },
  { name: "Pizzarias", icon: Pizza, color: "text-maraca-pink", bg: "hover:bg-maraca-pink/10" },
  { name: "Mercado", icon: ShoppingCartSimple, color: "text-maraca-navy", bg: "hover:bg-maraca-navy/10" },
  { name: "Farmácia", icon: Pill, color: "text-maraca-teal", bg: "hover:bg-maraca-teal/10" },
  { name: "Bebidas", icon: BeerBottle, color: "text-maraca-amber", bg: "hover:bg-maraca-amber/10" },
  { name: "Açaí", icon: BowlFood, color: "text-maraca-pink", bg: "hover:bg-maraca-pink/10" },
  { name: "Doces", icon: Cake, color: "text-maraca-navy", bg: "hover:bg-maraca-navy/10" },
  { name: "Outros", icon: DotsThreeOutline, color: "text-maraca-pink", bg: "hover:bg-maraca-pink/10" },
];

const agendamento = [
  { name: "Salão de Beleza", icon: Scissors, color: "text-maraca-pink", bg: "hover:bg-maraca-pink/10", to: "/servicos/salao-de-beleza" },
  { name: "Manicure", icon: PaintBrush, color: "text-maraca-amber", bg: "hover:bg-maraca-amber/10", to: "/servicos/manicure" },
  { name: "Clínicas", icon: Stethoscope, color: "text-maraca-teal", bg: "hover:bg-maraca-teal/10", to: "/servicos/clinica" },
];

const Card = ({ cat }) => (
  <motion.div
    variants={fadeUp}
    data-testid={`category-${cat.name.toLowerCase().replace(/\s/g, "-")}`}
    className={`group flex cursor-pointer flex-col items-start gap-4 rounded-2xl border border-black/5 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${cat.bg}`}
  >
    <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-slate-50 transition-transform duration-300 group-hover:scale-110">
      <cat.icon size={30} weight="duotone" className={cat.color} />
    </span>
    <span className="font-display text-lg font-bold text-maraca-navy">{cat.name}</span>
  </motion.div>
);

const ScheduleCard = ({ cat }) => (
  <motion.div variants={fadeUp}>
    <Link
      to={cat.to}
      data-testid={`agendamento-link-${cat.name.toLowerCase().replace(/\s/g, "-")}`}
      className={`group flex h-full flex-col items-start gap-4 rounded-2xl border border-black/5 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${cat.bg}`}
    >
      <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-slate-50 transition-transform duration-300 group-hover:scale-110">
        <cat.icon size={30} weight="duotone" className={cat.color} />
      </span>
      <span className="font-display text-lg font-bold text-maraca-navy">{cat.name}</span>
      <span className="mt-auto inline-flex items-center gap-1 text-sm font-bold text-maraca-navy/60 transition-colors group-hover:text-maraca-navy">
        Ver como funciona
        <ArrowUpRight size={16} weight="bold" className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </span>
    </Link>
  </motion.div>
);

export const Categories = () => (
  <section id="categorias" className="bg-white py-24 md:py-32" data-testid="categories-section">
    <div className="mx-auto max-w-8xl px-5 md:px-10">
      <div className="mb-14 max-w-2xl">
        <p className="mb-3 font-mono text-xs font-bold uppercase tracking-[0.2em] text-maraca-teal">
          Tudo em um só app
        </p>
        <h2 className="font-display text-4xl font-extrabold tracking-tight text-maraca-navy md:text-5xl lg:text-6xl">
          Categorias que a gente entrega
        </h2>
        <p className="mt-4 text-lg text-maraca-navy/70">
          Do almoço ao remédio, do açaí aos doces — Maracás inteira na sua tela.
        </p>
      </div>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={viewport}
        className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4"
      >
        {delivery.map((cat) => <Card key={cat.name} cat={cat} />)}
      </motion.div>

      <div className="mb-10 mt-24 max-w-2xl" data-testid="agendamento-block">
        <p className="mb-3 font-mono text-xs font-bold uppercase tracking-[0.2em] text-maraca-pink">
          Agende sem sair de casa
        </p>
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-maraca-navy md:text-4xl lg:text-5xl">
          Categorias de agendamento em casa
        </h2>
        <p className="mt-4 text-lg text-maraca-navy/70">
          Serviços de beleza e saúde marcados pelo app e realizados no conforto da sua casa.
        </p>
      </div>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={viewport}
        className="grid grid-cols-2 gap-4 sm:grid-cols-3"
      >
        {agendamento.map((cat) => <ScheduleCard key={cat.name} cat={cat} />)}
      </motion.div>
    </div>
  </section>
);
